import { defineMessages } from 'react-intl-next';

export const messages: {
    defaultPlaceholder: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	defaultPlaceholder: {
		id: 'company-hub.article-search-component.placeholder',
		defaultMessage: 'Search for help',
		description: 'Default placeholder text for the article search input.',
	},
});
